import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { api } from './api/client'
import { useUIStore } from './stores/ui'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

// Set up session expiration callback
const uiStore = useUIStore(pinia)
api.onSessionExpired(() => {
  uiStore.showSessionTimeout()
})

app.mount('#app')
